import React from 'react';
import HouseIcon from '@mui/icons-material/House';
import Tooltip from '@mui/material/Tooltip';
import Badge from '@mui/material/Badge';
import IconButton from '@mui/material/IconButton';
import useDebugInformation from '../../hooks/useDebugInformation';
import { state, temp, ui } from '../../interfaces/interfaces';
import { AddressPrefix } from '../../utilities/BasicTypes';
import { AddressUtils } from '../../utilities/address';
import { useAppSelector } from "@store/hooks";

const name = "HouseButtonBR"

type Props = {
    tooltip: string;
    prefix: AddressPrefix;
    parent: string;
    disabledBtn?: boolean
}

const fetchMergedAddresses = async (prefix: AddressPrefix) => {
    await AddressUtils.mergeAddresses({ prefix, temp, ui })
}

const HouseButtonBR: React.FC<Props> = ({ tooltip, prefix, parent, disabledBtn }) => {
    const addressFormValid = useAppSelector(({ state }) => state[`${prefix}Valid`])
    const length = useAppSelector(({ temp }) => temp[`${prefix}AddressesLength`])
    const forceIconRefresh = useAppSelector(({ state }) => state.ForceHouseIconCount)

    React.useEffect(() => {
        fetchMergedAddresses(prefix)
    }, [prefix])
    
    React.useEffect(() => {
        state.ForceHouseIconCount = false
        fetchMergedAddresses(prefix)
    }, [forceIconRefresh, prefix])


    const debugName = `${parent}▷[${name}]`

    const showModal = React.useCallback(() => AddressUtils.showAddressModal({ ui, prefix }), [prefix])

    useDebugInformation(debugName, { tooltip, prefix, parent, disabledBtn, addressFormValid, length })
    return (
        <Tooltip title={tooltip ? tooltip : "House"} >
            <span>
                <IconButton onClick={showModal} hidden={length > 0 ? false : true} disabled={disabledBtn ? disabledBtn : false}>
                    <Badge badgeContent={length ? length : 0} color="primary" invisible={disabledBtn ? disabledBtn : false} >
                        <HouseIcon color={disabledBtn ? "disabled" : "action"} />
                    </Badge>
                </IconButton>
            </span>
        </Tooltip>
    )
}

export default React.memo(HouseButtonBR);